import { render, staticRenderFns } from "./InvoiceToken.vue?vue&type=template&id=8d152cda"
import script from "./InvoiceToken.vue?vue&type=script&lang=js"
export * from "./InvoiceToken.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports